import { DatasetUploadsPage, type DatasetUploadsPageProps } from "@/components/dataset-uploads/DatasetUploadsPage"
import { masterProductDistConfig } from "@/lib/datasetRegistry"

// Thin config module — the whole page is the parameterized <DatasetUploadsPage>
// driven by `masterProductDistConfig` (app/frontend/lib/datasetRegistry.ts). Controller
// renders this via inertia page name "admin/master_product_dist/Uploads".
export default function AdminMasterProductDistUploads(props: Omit<DatasetUploadsPageProps, "config">) {
  return <DatasetUploadsPage config={masterProductDistConfig} {...props} />
}
